<template>
  <div v-if="!refresh">
    <div ref="result"/>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/turkish-restaurants">Live Cities</a></li>
        <li class="breadcrumb-item"><a :href="getCityUrl">{{ getCityText }}</a></li>
        <li class="breadcrumb-item active" aria-current="page"> {{selected_city}}</li>
      </ol>
    </nav>
    <h3 class="text-primary mt-4" >{{ selected_city }} Restaurants</h3>
    <tabs-restaurant :area_id="area_id"></tabs-restaurant>
<!--    <live-cities-list :area_id="area_id" />-->
    <article v-if="liveCity" class="live-city-about" v-html="liveCity.content"></article>
  </div>
</template>

<script>
import TabsRestaurant from '../tabs/TabsRestaurant'
import LiveCitiesList from './components/LiveCitiesList'
export default {
  props: {
    city: {
      type: String
    },
    area: {
      type: String
    }
  },
  components: {
    LiveCitiesList,
    TabsRestaurant
  },

  metaInfo () {
    return {
      title: `Explore Turkish Cuisine in ${this.selected_city}, ${this.getCityText} | Live Cities`,
      titleTemplate: '%s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `Dive into the diverse Turkish culinary scene in ${this.selected_city}, ${this.getCityText}. Discover hidden gems and popular spots serving authentic Turkish delights like doner kebab, borek, and more on Live Cities.`
        }
      ]
    }
  },
  data () {
    return {
      refresh: false,
      placeService: null,
      geocoder: null,
      liveCity: null,
      cityUrl: null,
      area_id: null
    }
  },
  watch: {
    area_id () {
      this.handleAddress()
      this.getCityContent()
      this.refresh = true
    },
    refresh () {
      if (this.refresh) {
        setTimeout(() => {
          this.refresh = false
        }, 500)
      }
    }
  },
  methods: {

    getArea () {
      this.$vs.loading()

      const payload = {
        city: `${this.selected_city}`
      }
      this.$store.dispatch('api/getAreaText', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.cityData = response.data
          this.area_id = this.cityData.id.toString()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getPlaceDetails (place_id, callback) {
      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        callback(PlaceResult)
      })
    },
    getAddressLocation (address_text, callback) {
      const addressObj = {
        address: address_text,
        country: 'United States'
      }
      this.geocoder.geocode(addressObj, (response, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          callback(response[0].place_id)
        }
      })
    },
    handleAddress () {

      const place_str = `${this.getAreaText}, ${this.getCityText}`

      this.getAddressLocation(place_str, (response) => {
        this.getPlaceDetails(response, (response) => {
          if (response.photos) {
            const url = response.photos[Math.floor(Math.random() * response.photos.length)].getUrl()
            this.$store.dispatch('api/setSelectedImage', url)
          }
        })
      })
    },
    getCityContent () {
      this.$vs.loading()

      const payload = {
        alias: `${this.city}/${this.area}`
      }
      this.$store.dispatch('api/liveCityList', payload)
        .then(() => {
          this.$vs.loading.close()
          this.liveCity = this.$store.state.api.liveCities[0]
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  computed: {
    getCityUrl () {
      return `/turkish-restaurants-${this.getCityText.toLowerCase().replace(' ', '-')}`
    },
    getCityText () {
      const words = this.city.split('-')
      let last_words = []
      words.map(word => {
        word = word.substring(0, 1).toUpperCase().concat(word.substring(1))
        last_words.push(word)
      })
      last_words = last_words.join(' ')
      return last_words
    },
    getAreaText () {
      const words = this.area.split('-')
      let last_words = []
      words.map(word => {
        word = word.substring(0, 1).toUpperCase().concat(word.substring(1))
        last_words.push(word)
      })
      last_words = last_words.join(' ')
      return last_words
    },
    selected_city () { return localStorage.getItem('selected_city') || this.$store.state.api.selected_city }
  },
  mounted () {
    this.geocoder = new window.google.maps.Geocoder(this.$refs.result)
    this.placeService = new window.google.maps.places.PlacesService(this.$refs.result)
    this.$store.dispatch('api/setSelectedCity', this.getAreaText)
    this.handleAddress()
    this.getCityContent()
    this.getArea()
  }
}
</script>
<style lang="scss">
.live-city-about{
  font-size:18px;
  margin-top:20px;
  box-shadow:0px 0px 9px 6px rgba(0,0,0,0.1);
  border-radius: 3px;
  padding:15px;
  //text-align: justify;
  font-family:serif;
  font-weight: 500;
  column-count: 2;
  column-gap: 60px;
}
.breadcrumb {
  padding: 20px 0 10px 0;
  margin-bottom: 20px;
  list-style: none;
  background-color: #ffffff;
  border-radius: 4px;
}
</style>
